import * as t from 'io-ts';

import {
  defaultLastWriterWinsValue,
  mergeLastWriterWinsValue,
  RLastWriterWinsValue,
} from './lastWriterWinsValue';

/*
 * Runtime types.
 */

export const RAiTermsAndPrivacyAcceptance = t.intersection([
  RLastWriterWinsValue,
  t.type({
    acceptedVersion: t.number,
  }),
]);

export type AiTermsAndPrivacyAcceptance = t.TypeOf<typeof RAiTermsAndPrivacyAcceptance>;

/*
 * Defaults.
 */

export const defaultAiTermsAndPrivacyAcceptance: AiTermsAndPrivacyAcceptance = {
  ...defaultLastWriterWinsValue,
  acceptedVersion: 0,
};

/*
 * Merge strategy.
 */

export const mergeAiTermsAndPrivacyAcceptance = mergeLastWriterWinsValue<AiTermsAndPrivacyAcceptance>;
